// extracted by mini-css-extract-plugin
export default {"course_card":"course_course_card__u6uk0"};